module.exports = {
  latestClaimsDate: new Date('2025-09-30'),
};
